import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { GetFooterDetails } from "../../Services/UtilitiesServices";
import { withTranslation } from 'react-i18next';
function Footer({ t, i18n }) {
  const navigate = useNavigate();

  const PrivacyPolicy = () => {
    navigate('/Privacy_Policy');
  };

  const Disclaimer = () => {
    navigate('/Disclaimer');
  };
  const TermsofUse = () => {
    navigate('/TermsofUse');
  };

const [email, setEmail] = useState("");
const [contactNo, setContactNo] = useState("");
const [country, setCountry] = useState(localStorage.getItem("selectedCountryCode"));

const getHolidaysUrl = () => {
  const countryCode = localStorage.getItem("selectedCountryCode");

  const holidayUrls = {
    IN: "https://www.alhindholidays.com/",
    AE: "https://ae.alhindholidays.com/",
    SA: "https://www.alhindholidays.com/",
    KW: "https://www.alhindholidays.com/",
  };

  return holidayUrls[countryCode] || "https://www.alhindholidays.com/";
};




// 🔥 Detect country change (manual trigger)
useEffect(() => {
  const interval = setInterval(() => {
    const currentCountry = localStorage.getItem("selectedCountryCode");
    if (currentCountry !== country) {
      setCountry(currentCountry);
    }
  }, 500); // check every 0.5 sec

  return () => clearInterval(interval);
}, [country]);


// 🔥 Fetch API when country changes
useEffect(() => {
  if (!country) return;

  const fetchFooter = async () => {
    try {
      console.log("Calling API for country:", country);
      const res = await GetFooterDetails();
      setEmail(res.data.b2CEmail);
      setContactNo(res.data.b2CContactNo);
    } catch (error) {
      console.error("Footer API error:", error);
    }
  };

  fetchFooter();
}, [country]);

  const currentYear = new Date().getFullYear();

const getHomeRoute = () => {
  const country = localStorage.getItem("selectedCountryCode");

  const countryRoutes = {
    AE: "/AE",
    SA: "/SA",
    QA: "/QA",
    BA: "/BA",
    OM: "/OM",
    KW: "/KW",
  };

  return countryRoutes[country] || "/";
};
  

  return (
    <div>
       <div>
        {/* <div className="top-footer">
          <div className="container">
            <div className="d-flex">
              <div className="top-footer-links">
                <a >International Flight Tickets</a>
                <a >Domestic Flight Tickets</a>
              </div>
            </div>
          </div>
        </div> */}
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-12 footer-widget">
                <img src="/assets/img/logo-alhind.webp" alt=""/>
              <ul className="social">
<li><Link to="https://www.facebook.com/alhindgroup/" target="_blank"><span className="facebook"></span></Link></li>
<li><Link to="https://www.instagram.com/alhind_com/" target="_blank"><span className="insta"></span></Link></li>
<li><Link to="https://www.linkedin.com/company/alhindonline" target="_blank"><span className="linked"></span></Link></li>
<li><Link to="https://www.youtube.com/AlhindOnline" target="_blank"><span className="ytub"></span></Link></li>
<li><Link to="https://twitter.com/alhindonline" target="_blank"><span className="twitter"></span></Link></li>
              </ul>
              </div>
              <div className="col-lg-3 col-md-3 col-6 footer-widget">
                <h4>{t('useful_links')}</h4>
                <ul>
                      <li><Link to="https://alhindgroup.com/" target="_blank">{t('about_us')}</Link></li>
                <li>
                  <a onClick={Disclaimer}>{t('disclaimer')}</a>
                 
                  </li>
                  <li>
                  <a onClick={PrivacyPolicy}>{t('privacy_policy')}</a>
                 
                  </li>
                  <li>
                  <a onClick={TermsofUse}>{t('terms_of_use')}</a>
                 
                  </li>
                </ul>
              </div>
             <div className="col-lg-3 col-md-3 col-6 footer-widget">
                <h4>{t('services')}</h4>
                <ul className="footer-service">
                  <li>
                    <Link to={getHomeRoute()}>{t('flights')}</Link>
                  </li>

                  <li>
                    <a href={getHolidaysUrl()} target="_blank" rel="noopener noreferrer">
                      {t('holidays')}
                    </a>
                  </li>

                  <li>
                    <Link to="Hotel">{t('hotel')}</Link>
                  </li>

                  <li>
                    <Link to="Visa">{t('visa')}</Link>
                  </li>

                  <li>
                    <Link to="Forex">{t('forex')}</Link>
                  </li>

                  <li>
                    <Link to="Insurance">{t('insurance')}</Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-3 col-12 footer-widget">
                <h4>{t('connect_us')}</h4>
                <ul>
             {/* <li>0495 2389900</li>  */}
                  <li>
                    {email ? (
                      <a href={`mailto:${email}`}>{email}</a>
                    ) : (
                      "Loading..."
                    )}
                  </li>
                  <li>
                    {contactNo ? (
                      <a href={`mailto:${contactNo}`}>{contactNo}</a>
                    ) : (
                      "Loading..."
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="copyright">
            <div className="container">
            <div className="d-flex flex-row align-items-center">
  <div className="c-text">
    <p>{t('copyright')}</p>
  </div>
  <div className="flex-grow-1"></div> 
  <div className="payment">
 
    <img src="/assets/img/payments.png" />
  </div>
</div>

            
            </div>
          
          </div>
        </footer>
        <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Sign in to your Alhind Account!</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <form className="login-form" id="login" >
                  <input type="text" className="form-control" defaultValue="Enter Mobile Number" />
                  <button type="submit" className="btn btn-primary">GET OTP</button>
                  <div className="pt-2 pb-2">
                    <p className="or-section">Or</p>
                  </div>
                  <div className="text-center">
                    <a  className="google-login"><img src="/assets/img/Google__G__Logo.svg" width={30} alt=""/> Sign in with Google</a>
                  </div>
                  <div className="pt-3 pb-3 small-text text-center"><p>By continuing, you agree to our <a  className="privacy-link">privacy policy &amp; terms of use.</a></p></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation()(Footer);
